export default {
  "connect.title": "Scan to connect",
  "connect.description": "Scan the QR code with WhatsApp",

  "connect.guide.title": "How to connect WhatsApp account?",
  "connect.guide.1":
    'For iOS users, open WhatsApp and tap the "Settings" menu, then select "Linked Devices"; for Android users, tap the "Chats" menu, tap the "More" icon in the top right corner, and select "Linked Devices"',
  "connect.guide.2":
    'Enter the connected devices page and click the "Connect Device" button at the bottom',
  "connect.guide.3": 'Tap "OK" to start scanning',

  "connected.title": "Connected",
  "connected.description": "You can open 12Times App to start using",
};
